import React from 'react';
import PropTypes from 'prop-types';

const WeatherReportError = ({ message, link }) => {
  if (link.url) {
    return (
      <a href={link.url} target={link.target}>
        {message}
      </a>
    );
  }
  return <p>{message}</p>;
};

WeatherReportError.propTypes = {
  message: PropTypes.string.isRequired,
  link: PropTypes.object
};

export default WeatherReportError;
